import type { RequestFn } from '../http';

export function createPushApi(request: RequestFn) {
  return {
    getPushVapidKey(): Promise<{ publicKey: string }> {
      return request('/push/vapid-public-key');
    },

    subscribePush(subscription: PushSubscriptionJSON): Promise<{ ok: boolean }> {
      return request('/push/subscribe', {
        method: 'POST',
        body: JSON.stringify({
          endpoint: subscription.endpoint,
          keys: {
            p256dh: subscription.keys?.p256dh ?? '',
            auth: subscription.keys?.auth ?? '',
          },
        }),
      });
    },

    unsubscribePush(endpoint: string): Promise<{ ok: boolean }> {
      return request('/push/subscribe', {
        method: 'DELETE',
        body: JSON.stringify({ endpoint }),
      });
    },
  };
}
